/**
 * Route for `creative-hosting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CreativeHostingPage } from "../features/creative-hosting/CreativeHostingPage";

export const creativeHostingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/creative-hosting",
	component: CreativeHostingPage,
});

export default creativeHostingRoute;
